import { defineStore } from "pinia";

export const useStoryTypeRenderConfigStore = defineStore("story-type-render-config-store", {
  state: () => ({
    renderConfig: null,
  }),
  getters: {
    hasRenderConfig() {
      return this.renderConfig !== null;
    },
    enabledStoryTypeKeys() {
      const enabledMap = this.renderConfig?.enabledMap ?? {};
      return Object.keys(enabledMap).filter(storyType => enabledMap[storyType]);
    },
  },
});
